<section class="small-wrapper">
    <h2>Deine Bestellungen</h2>
</section>

<style lang="less">
    .small-wrapper {
        flex-grow: 1;
    }
</style>
